import { getLocalStorage } from './storage';

interface LocalStorageServiceClass {
  key: string;
  setLocal: (payload: any) => void;
  getLocal: () => void;
  removeLocal: () => void;
}

class LocalStorageService implements LocalStorageServiceClass {
  key: string = '';

  constructor(key: string) {
    this.key = key;
  }

  setLocal(payload: any) {
    getLocalStorage().setItem(this.key, JSON.stringify(payload));
  }

  getLocal = () => {
    const stringifiedCache = getLocalStorage().getItem(this.key);

    const localCache = stringifiedCache ? JSON.parse(stringifiedCache) : null;

    return localCache;
  };

  removeLocal = () => {
    getLocalStorage().removeItem(this.key);
  };
}

export default LocalStorageService;
